import { useCaseSite } from '../app/caseSite';
import { orderLocales, useI18n, useT } from '../i18n';

/**
 * Native <select> (the most familiar picker on phones), visually reduced to the language code
 * so the header fits at 360px. The real select is transparent and covers the label.
 * Lists every available language (built-in + added in the CRM); the languages of the case site come first.
 */
export function LanguagePicker() {
  const t = useT();
  const locale = useI18n((s) => s.locale);
  const locales = useI18n((s) => s.locales);
  const setLocale = useI18n((s) => s.setLocale);
  const caseLocales = useCaseSite((s) => s.site?.locales);
  const list = orderLocales(locales, caseLocales);
  return (
    <label className="relative inline-flex min-h-tap min-w-tap items-center justify-center gap-1 px-2 text-[14px] uppercase tracking-[.12em] text-txt focus-within:text-fg hover:text-fg has-[:focus-visible]:outline has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-fg">
      <span className="sr-only">{t('lang.label')}</span>
      <span aria-hidden>{locale}</span>
      <svg className="text-lab" width="10" height="10" viewBox="0 0 10 10" aria-hidden>
        <path d="M1 3l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.6" />
      </svg>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        className="absolute inset-0 h-full w-full cursor-pointer appearance-none opacity-0"
      >
        {list.map((l) => (
          <option key={l.code} value={l.code} lang={l.code}>
            {l.name}
          </option>
        ))}
      </select>
    </label>
  );
}
